import "./Journal.module.css";
import Header from "@/reusable_sections/Header";
import CampusBulletins from "./sections/CampusBulletins";
import DropAlerts from "./sections/DropAlerts";
import Footer from "@/reusable_sections/Footer";
export default function JournalPage() {
  return <div>
      <Header />
      <CampusBulletins />
      <DropAlerts />
      <Footer />
    </div>;
}